"use strict";
/*
 * Created on 25. 3. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Converter of {@link SelloutReleaseItemKey}.
 * @author Radek Beran
 */


var SelloutReleaseItemKeyConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseItemKeyConverter, _DataObjectConverter_);

  function SelloutReleaseItemKeyConverter() {
    _classCallCheck(this, SelloutReleaseItemKeyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemKeyConverter).apply(this, arguments));
  }

  return SelloutReleaseItemKeyConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseItemKeyConverter = SelloutReleaseItemKeyConverter;